import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './cabinet-help-link.css';

export interface CabinetHelpLinkProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

export function CabinetHelpLink({ children, className = '', ...props }: CabinetHelpLinkProps) {
  return (
    <button
      type="button"
      className={`cabinet-help-link ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}
